// extracted by mini-css-extract-plugin
export default {"MenuBarSection":"menuBar_MenuBarSection__zpoI9","MenuBar":"menuBar_MenuBar__7MUdK","active":"menuBar_active__0XPPd"};